// src/components/task/PriorityHelpModal.tsx
import React, { useState } from 'react';
// import Modal from '../../common/ui/Modal';
import Modal from 'src/components/common/ui/Modal';

export default function PriorityHelpModal() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                aria-label="Priority 설명 보기"
                className="ml-1 inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px]
                   border border-gray-300 text-gray-600 hover:bg-gray-50"
                onClick={() => setOpen(true)}
                title="Eisenhower Matrix 설명"
            >
                ?
            </button>

            <Modal open={open} onClose={() => setOpen(false)} title="Priority (Eisenhower Matrix)" size="xl">
                <div className="text-sm space-y-4">
                    <p className="text-gray-700">
                        Priority는 <b>긴급도(Urgency)</b> × <b>중요도(Importance)</b> (1~5)로 계산됩니다. 점수(1~25)와
                        사분면(아이젠하워 매트릭스)을 함께 사용해 업무 우선순위를 정합니다.
                    </p>

                    {/* 2x2 아이젠하워 매트릭스 */}
                    <div className="grid grid-cols-2 gap-3">
                        <div className="rounded-lg border p-3">
                            <div className="text-xs text-gray-500 mb-1">중요 & 긴급</div>
                            <div className="font-medium">DO_NOW</div>
                            <p className="text-xs text-gray-600 mt-1">즉시수행; 장애, 임박 마감 등 지연 시 큰 영향.</p>
                        </div>
                        <div className="rounded-lg border p-3">
                            <div className="text-xs text-gray-500 mb-1">중요 & 비긴급</div>
                            <div className="font-medium">SCHEDULE</div>
                            <p className="text-xs text-gray-600 mt-1">계획수행; 일정 잡고 계획적으로. 설계·개선·전략성 작업.</p>
                        </div>
                        <div className="rounded-lg border p-3">
                            <div className="text-xs text-gray-500 mb-1">비중요 & 긴급</div>
                            <div className="font-medium">DELEGATE</div>
                            <p className="text-xs text-gray-600 mt-1">위임수행; 위임·분담 고려. 반복 행정/지원 업무 등.</p>
                        </div>
                        <div className="rounded-lg border p-3">
                            <div className="text-xs text-gray-500 mb-1">비중요 & 비긴급</div>
                            <div className="font-medium">ELIMINATE</div>
                            <p className="text-xs text-gray-600 mt-1">제외(미실시); 제거·자동화 대상. 가치 낮은 잡무 최소화.</p>
                        </div>
                    </div>

                    {/* 색상/점수 가이드 */}
                    <div className="rounded-lg border p-3">
                        <div className="text-xs text-gray-500 mb-2">Score 가이드 (Urgency×Importance)</div>
                        <ul className="text-xs text-gray-700 space-y-1">
                            <li>
                                <b>16–25</b> : 매우 높은 우선순위 (보통 Red 느낌)
                            </li>
                            <li>
                                <b>9–15</b> : 높은 우선순위 (Amber/Orange)
                            </li>
                            <li>
                                <b>4–8</b> : 보통 우선순위 (Yellow/Green)
                            </li>
                            <li>
                                <b>1–3</b> : 낮은 우선순위 (Gray/Green)
                            </li>
                        </ul>
                        <p className="text-[11px] text-gray-500 mt-2">
                            * 실제 색상은 프로젝트의 스타일 가이드/테마에 따라 다를 수 있습니다.
                        </p>
                    </div>

                    {/* 팁 */}
                    <div className="rounded-lg border p-3">
                        <div className="text-xs text-gray-500 mb-1">Tips</div>
                        <ul className="list-disc pl-5 text-xs text-gray-700 space-y-1">
                            <li>우선순위가 높은 작업일수록 Due Date, Assignee를 명확히 지정하세요.</li>
                            <li>주간 리뷰 때 긴급/중요 스코어를 재평가하여 최신 상태를 유지하세요.</li>
                            <li>DELEGATE/ELIMINATE 후보는 목록에서 분리해 관리해도 좋습니다.</li>
                        </ul>
                    </div>

                    <div className="mt-2 text-right">
                        <button
                            type="button"
                            className="text-xs rounded border px-2.5 py-1 hover:bg-gray-50"
                            onClick={() => setOpen(false)}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
